import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.js";
import { Link } from "react-router-dom";

export default function Services() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">Услуги</h1>
      <Link to="/services/udalenie-papillom" className="strip__content">
        Удаление папиллом
      </Link>
    </section>
  );
}
